import Vue from 'vue'
import dayjs from './dayjs'
import signalr from './signalr'
import './helpers'
import './axios'
import './auth'
import './i18n'
import './vuelidate'
import './buefy'
import './sidebar'
import './ckeditor'
import './v-calendar'
import './vue-scrollto'
import './google-charts'
import './gapi'

Vue.use(dayjs)
Vue.use(signalr)
